var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_vm._m(0),_c('news-popular',{attrs:{"data":_vm.popularNews}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"text-primary mb-4"},[_c('strong',[_vm._v("Berita Populer")])])
}]

export { render, staticRenderFns }